function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import * as React from 'react';
// import PropTypes from 'prop-types';

import { DndProvider, Container, Draggable } from 'granite-admin/core/components/DndSuite';
import { classes } from '../utils';
export const Header = /*#__PURE__*/React.memo(({
  TheadComponent,
  ThComponent,
  TrComponent,
  headerGroups,
  getTableBodyProps,
  setColumnOrder,
  flatColumns,
  reorderable,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(TheadComponent, {
    style: {
      ...(getTableBodyProps()?.style ?? {})
    }
  }, headerGroups.map((headerGroup, index) => /*#__PURE__*/React.createElement(DndProvider, {
    key: index
  }, /*#__PURE__*/React.createElement(Container, {
    nonDragAreaSelector: ".rt-resizer",
    lockAxis: "x",
    onDrop: dropResult => {
      const {
        removedIndex,
        addedIndex
      } = dropResult;
      const columns = [...(flatColumns ?? [])];
      const colOrder = columns.map(o => o.id);
      if (typeof removedIndex === 'number' && typeof addedIndex === 'number' && !columns[addedIndex]?.disableOrdering && !columns[removedIndex]?.disableOrdering) {
        let [data] = colOrder.splice(removedIndex, 1);
        colOrder.splice(addedIndex, 0, data);
        setColumnOrder(colOrder);
      }
    },
    groupName: "droppable",
    orientation: "horizontal",
    render: ref => /*#__PURE__*/React.createElement(TrComponent, {
      ref: ref,
      className: "tr"
    }, headerGroup.headers.map((column, index) => /*#__PURE__*/React.createElement(Draggable, {
      key: column.id,
      render: ref => /*#__PURE__*/React.createElement(HeaderCell, _extends({
        reorderable: reorderable,
        ref: ref,
        ThComponent: ThComponent,
        column: column
      }, rest))
    })))
  }))));
});
Header.displayName = 'Header';
Header.propTypes = {
  // add your proptypes here
  // cells: PropTypes.array.isRequired,
};
const HeaderCell = ({
  ThComponent,
  SortIconComponent,
  column,
  resizable,
  className,
  reorderable
}) => {
  return /*#__PURE__*/React.createElement(ThComponent, _extends({
    key: column.id
  }, column.getHeaderProps(), {
    className: classes(`${!reorderable || column.disableOrdering ? '' : className}`,
    // the draggable classname
    `${column.isResizing ? 'rt-resizing' : ''}`, `${column.id}`, `${column.canResize ? 'rt-resizable-header' : ''}`),
    id: column.id
  }), /*#__PURE__*/React.createElement("div", _extends({
    className: classes(column.canResize && 'rt-resizable-header-content'
    // column.align === 'right' && 'rt-right-align',
    )
  }, column.getSortByToggleProps()), column.render('Header'), column.canSort ? /*#__PURE__*/React.createElement(SortIconComponent, {
    column: column
  }) : null), column.canResize && /*#__PURE__*/React.createElement("div", _extends({}, resizable ? column?.getResizerProps?.() ?? {} : {}, {
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
    },
    className: `rt-resizer${column.isResizing ? ' isResizing' : ''}${!resizable ? ' normalCursor' : ''}`
  })));
};
HeaderCell.displayName = 'HeaderCell';